import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface RearElectricEngineProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function RearElectricEngine(props: RearElectricEngineProps) {
  return (
    <svg
      width="84"
      height="80"
      viewBox="0 0 84 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{top: 211, right: 264}}
      onClick={props.onClick}
    >
      <path
        d="M1 63C1 65 3 65 3 65H9L8.99997 67C8.99997 69 11 69 11 69L12 69V70C12 75 17 75 17 75L18 75V77C18 79 20 79 20 79H46H72C72 79 74 79 74 77V75L75 75C75 75 80 75 80 70V69L81 69C81 69 83 69 83 67V49V13C83 11 81 11 81 11H80V10C80 5.00001 75 5.00002 75 5.00002L74 5V3C74 1 72 1 72 1H46H20C20 1 18 1 18 3V5L17 5.00002C17 5.00002 12 5.00001 12 10V11H11C11 11 8.99997 11 8.99997 13L9 15H3C3 15 1 15 1 17V49V63Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M12 11L12 10C12 5.00001 17 5.00002 17 5.00002H46H75C75 5.00002 80 5.00001 80 10V11"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M18 5V3C18 1 20 1 20 1H46H72C72 1 74 1 74 3V5"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M12 69L12 70C12 75 17 75 17 75H46H75C75 75 80 75 80 70V69"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M18 75V77C18 79 20 79 20 79H46H72C72 79 74 79 74 77V75"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M9.00003 65L9 67C9 69 11 69 11 69H46H81C81 69 83 69 83 67V40V13C83 11 81 11 81 11H46H11C11 11 9 11 9 13L9.00003 15"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M3 65H11H19C19 65 21 65 21 63V40V17C21 15 19 15 19 15H11H3C3 15 1 15 1 17V40V63C1 65 3 65 3 65Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M51 11V69"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M41 11V69"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path d="M33 11V69" stroke="currentColor" className={partStroke({variant: props.variant})} />
      <path d="M59 11V69" stroke="currentColor" className={partStroke({variant: props.variant})} />
      <path d="M75 11V69" stroke="currentColor" className={partStroke({variant: props.variant})} />
      <path
        d="M67 11V69"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeDasharray="2 2"
      />
      <path
        d="M25 11V69"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeDasharray="2 2"
      />
    </svg>
  );
}
